var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8.09995 1.7998c-.34089 0-.65253.19261-.80498.49751l-.65125 1.30249h-3.04377c-.49706 0-.9.40295-.9.9 0 .49706.40295.9.9.9v9c0 .9941.80589 1.8 1.8 1.8h7.20005c.9941 0 1.8-.8059 1.8-1.8v-9c.497 0 .9-.40294.9-.9 0-.49705-.403-.9-.9-.9h-3.0438l-.6513-1.30249c-.1524-.3049-.4641-.49751-.80495-.49751zm-1.8 5.4c0-.49705.40295-.9.9-.9.49706 0 .9.40295.9.9v5.4c0 .4971-.40294.9-.9.9-.49705 0-.9-.4029-.9-.9zm4.50005-.9c-.4971 0-.90005.40295-.90005.9v5.4c0 .4971.40295.9.90005.9.497 0 .9-.4029.9-.9v-5.4c0-.49705-.403-.9-.9-.9z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.445f29b4aee38d100afdbad1d3460db3.svg";
export { ForwardRef as ReactComponent };